import {
  getInfluencesArray,
  getAllPrimaryTopics,
} from "@/services/events/topics.service";

let icons = {
  menu: {
    alerts: {
      inactive: "/icons/menu_alerts_white.png",
      active: "/icons/menu_alerts_black.png",
      inactiveSvg: "/svgs/alerts_white.svg",
      activeSvg: "/svgs/alerts_primary.svg",
    },
    notifications: {
      inactive: "/icons/menu_notifications_white.png",
      active: "/icons/menu_notifications_black.png",
    },
    events: {
      inactive: "/icons/menu_events_white.png",
      active: "/icons/menu_events_black.png",
      inactiveSvg: "/svgs/events_white.svg",
      activeSvg: "/svgs/events_primary.svg",
    },
    incidents: {
      inactive: "/icons/controlRisksIncidents/incidents_white.png",
      active: "/icons/controlRisksIncidents/incidents_black.png",
      inactiveSvg: "/svgs/incidents_white.svg",
      activeSvg: "/svgs/incidents_primary.svg",
    },
    travelTracker: {
      inactive: "/icons/isosTravelTracker/menu_travel_tracker_white.png",
      active: "/icons/isosTravelTracker/menu_travel_tracker_black.png",
      inactiveSvg: "/svgs/travel_tracker_white.svg",
      activeSvg: "/svgs/travel_tracker_primary.svg",
    },
    powerOutage: {
      inactive: "/icons/powerOutage/menu_power_outage_white.png",
      active: "/icons/powerOutage/menu_power_outage_black.png",
      inactiveSvg: "/svgs/power_outage_white.svg",
      activeSvg: "/svgs/power_outage_primary.svg",
    },
    influences: {
      inactive: "/icons/menu_influences_white.png",
      active: "/icons/menu_influences_black.png",
      inactiveSvg: "/svgs/influences_white.svg",
      activeSvg: "/svgs/influences_primary.svg",
    },
    media: {
      inactive: "/icons/menu_media_white.png",
      active: "/icons/menu_media_black.png",
      inactiveSvg: "/svgs/media_white.svg",
      activeSvg: "/svgs/media_primary.svg",
    },
    comms: {
      inactive: "/icons/menu_comms_white.png",
      active: "/icons/menu_comms_black.png",
      inactiveSvg: "/svgs/comms_white.svg",
      activeSvg: "/svgs/comms_primary.svg",
    },
    places: {
      inactive: "/icons/menu_places_white.png",
      active: "/icons/menu_places_black.png",
      inactiveSvg: "/svgs/places_white.svg",
      activeSvg: "/svgs/places_primary.svg",
    },
    resources: {
      inactive: "/icons/menu_resources_white.png",
      active: "/icons/menu_resources_black.png",
      inactiveSvg: "/svgs/resources_white.svg",
      activeSvg: "/svgs/resources_primary.svg",
    },
    dashboard: {
      inactive: "/icons/menu_dashboard_white.png",
      active: "/icons/menu_dashboard_black.png",
      inactiveSvg: "/svgs/dashboard_white.svg",
      activeSvg: "/svgs/dashboard_primary.svg",
    },
    esri: {
      inactive: "/icons/menu_esri_white.png",
      active: "/icons/menu_esri_black.png",
      inactiveSvg: "/svgs/esri_white.svg",
      activeSvg: "/svgs/esri_primary.svg",
    },
    report: {
      inactive: "/icons/menu_report_white.png",
      active: "/icons/menu_report_black.png",
      inactiveSvg: "/svgs/report_white.svg",
      activeSvg: "/svgs/report_primary.svg",
    },
    collaboration: {
      inactive: "/icons/menu_collaboration_white.png",
      active: "/icons/menu_collaboration_black.png",
      inactiveSvg: "/svgs/collaboration_white.svg",
      activeSvg: "/svgs/collaboration_primary.svg",
    },
    profile: {
      inactive: "/icons/menu_profile_white.png",
      active: "/icons/menu_profile_black.png",
      inactiveSvg: "/svgs/profile_white.svg",
      activeSvg: "/svgs/profile_primary.svg",
    },
    stability: {
      inactive: "/icons/menu_stability_white.png",
      active: "/icons/menu_stability_black.png",
      inactiveSvg: "/svgs/stability_white.svg",
      activeSvg: "/svgs/stability_primary.svg",
    },
    hotspots: {
      inactive: "/icons/menu_hotspots_white.png",
      active: "/icons/menu_hotspots_black.png",
      inactiveSvg: "/svgs/hotspots_white.svg",
      activeSvg: "/svgs/hotspots_primary.svg",
    },
    search: {
      inactive: "/icons/menu_search_white.png",
      active: "/icons/menu_search_black.png",
      inactiveSvg: "/svgs/search_white.svg",
      activeSvg: "/svgs/search_primary.svg",
    },
    monitor: {
      inactive: "/icons/menu_monitor_white.png",
      active: "/icons/menu_monitor_black.png",
      inactiveSvg: "/svgs/monitor_white.svg",
      activeSvg: "/svgs/monitor_primary.svg",
    },
    signout: {
      inactive: "/icons/menu_signout_white.png",
      active: "/icons/menu_signout_white.png",
      inactiveSvg: "/svgs/signout_white.svg",
      activeSvg: "/svgs/signout_primary.svg",
    },
    latest: {
      inactive: "/icons/menu_latest_white.png",
      active: "/icons/menu_latest_black.png",
      inactiveSvg: "/svgs/latest_white.svg",
      activeSvg: "/svgs/latest_primary.svg",
    },
    cyber: {
      inactive: "/icons/menu_cyber_white.png",
      active: "/icons/menu_cyber_black.png",
      inactiveSvg: "/svgs/cyber_white.svg",
      activeSvg: "/svgs/cyber_primary.svg",
    },
    firi: {
      inactive: "/icons/menu_influences_white.png",
      active: "/icons/menu_influences_black.png",
      inactiveSvg: "/svgs/influences_white.svg",
      activeSvg: "/svgs/influences_primary.svg",
    },
    reporting: {
      inactive: "/icons/menu_reporting_pane_white.png",
      active: "/icons/menu_reporting_pane_black.png",
    },
  },
  types: {
    disasters: {
      inactive: "/icons/disasters_white.png",
      active: "/icons/disasters.png",
    },
    travel: {
      inactive: "/icons/events_travel_black.png",
      active: "/icons/events_travel_white.png",
    },
    news: {
      inactive: "/icons/news_white.png",
      active: "/icons/news.png",
    },
    social: {
      inactive: "/icons/social_white.png",
      active: "/icons/social.png",
    },
    alerts: {
      inactive: "/icons/alerts_white.png",
      active: "/icons/alerts.png",
    },
    hotspots: {
      inactive: "/icons/hotspots_white.png",
      active: "/icons/hotspots.png",
    },
    hotspotsCovid: {
      inactive: "/icons/hotspots_white.png",
      active: "/icons/hotspots_covid.png",
    },
    hotspotsSelected: {
      inactive: "/icons/hotspots_white.png",
      active: "/icons/hotspots_neutral.png",
    },
    places: {
      inactive: "/icons/places_black.png",
      active: "/icons/places_white.png",
    },
    locations: {
      active: "/icons/locations.png",
    },
    diplomacy_china_political: {
      active: "/icons/diplomacy_china_political.png",
    },
    diplomacy_china_economic: {
      active: "/icons/diplomacy_china_economic.png",
    },
    diplomacy_china_social: {
      active: "/icons/diplomacy_china_social.png",
    },
    diplomacy_china_infrastructure: {
      active: "/icons/diplomacy_china_infrastructure.png",
    },
    diplomacy_china_military: {
      active: "/icons/diplomacy_china_military.png",
    },
    diplomacy_china_information: {
      active: "/icons/diplomacy_china_information.png",
    },
    influencer_china: {
      active: "/icons/influencer_china.png",
    },
    influence_economic: {
      active: "/icons/influence_economic_black.png",
      inactive: "/icons/influence_economic_white.png",
    },
    influence_information: {
      active: "/icons/influence_information_black.png",
      inactive: "/icons/influence_information_white.png",
    },
    influence_infrastructure: {
      active: "/icons/influence_infrastructure_black.png",
      inactive: "/icons/influence_infrastructure_white.png",
    },
    influence_military: {
      active: "/icons/influence_military_black.png",
      inactive: "/icons/influence_military_white.png",
    },
    influence_political: {
      active: "/icons/influence_political_black.png",
      inactive: "/icons/influence_political_white.png",
    },
    influence_social: {
      active: "/icons/influence_social_black.png",
      inactive: "/icons/influence_social_white.png",
    },
    pulse: {
      inactive: "/icons/menu_stability_white.png",
      active: "/icons/menu_stability_black.png",
    },
    risks: {
      inactive: "/icons/info_viewer_white.png",
      active: "/icons/info_viewer_black.png",
    },
    travelTracker: {
      inactive: "/icons/isosTravelTracker/menu_travel_tracker_white.png",
      active: "/icons/isosTravelTracker/menu_travel_tracker_black.png",
    },
    powerOutage: {
      inactive: "/icons/powerOutage/menu_power_outage_white.png",
      active: "/icons/powerOutage/menu_power_outage_black.png",
    },
  },
  misc: {
    datePicker: {
      inactive: "/icons/date_picker_white.png",
      active: "/icons/date_picker_black.png",
    },
    mapSettings: {
      inactive: "/icons/map_settings_white.png",
      active: "/icons/map_settings_black.png",
      inactiveSvg: "/svgs/layers_primary.svg",
      activeSvg: "/svgs/layers_white.svg",
    },
    mapZoomIn: {
      inactive: "/icons/map_zoom_in_white.png",
      active: "/icons/map_zoom_in_black.png",
    },
    mapZoomOut: {
      inactive: "/icons/map_zoom_out_white.png",
      active: "/icons/map_zoom_out_black.png",
    },
    language: {
      inactive: "/icons/language.png",
      active: "/icons/language_black.png",
    },
  },
  places: {
    default: {
      inactive: "/icons/places_white.png",
      active: "/icons/places_white.png",
    },
  },
};

export function setTopicIcons() {
  // add the event topics icons to the main icons list
  let PRIMARY_TOPICS = getAllPrimaryTopics();
  PRIMARY_TOPICS.map((topic) => {
    icons.types[topic.type] = {
      inactive: `/icons/events_${topic.type}_black.png`,
      active: `/icons/events_${topic.type}_white.png`,
      selected: `/icons/events_${topic.type}_blue.png`,
      inactiveSvg: `/svgs/events_${topic.type}_black.svg`,
      activeSvg: `/svgs/events_${topic.type}_white.svg`,
      selectedSvg: `/svgs/events_${topic.type}_primary.svg`,
    };
  });

  icons.types["events_general"] = {
    inactive: `/icons/events_general_black.png`,
    active: `/icons/events_general_white.png`,
    selected: `/icons/events_general_blue.png`,
    inactiveSvg: `/svgs/events_black.svg`,
    activeSvg: `/svgs/events_white.svg`,
    selectedSvg: `/svgs/events_primary.svg`,
  };

  // add the influence topics icons to the the main icons list
  const INFLUENCES_ARRAY = getInfluencesArray();
  INFLUENCES_ARRAY.map((topic) => {
    icons.types[topic.apiName] = {
      inactive: `/icons/${topic.apiName}.png`,
      active: `/icons/${topic.apiName}.png`,
    };
  });
}

export const ICONS = icons;
